import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import rjListInsert from '../listInsert/index.es.js';
import rjListUpdate from '../listUpdate/index.es.js';
import rjListDelete from '../listDelete/index.es.js';
import { r as rjPlugin, S as SUCCESS } from '../../rjPlugin.es.js';
import 'object-path-immutable';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/toArray';
import 'rxjs';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/defineProperty';
import 'rxjs/operators';

var makeListDataReducer = function makeListDataReducer(customListReducer) {
  var defaultListReducer = function defaultListReducer(prevState, _ref) {
    var data = _ref.payload.data,
        meta = _ref.meta;
    var newList = data;

    if (meta && meta.append) {
      return (prevState || []).concat(newList);
    }

    if (meta && meta.prepend) {
      return newList.concat(prevState || []);
    }

    return newList;
  };

  var listReducer = typeof customListReducer === 'function' ? customListReducer : defaultListReducer;
  return function (prevState, action) {
    return listReducer(prevState, action);
  };
};
// Selectors for a list
var makeListSelectors = function makeListSelectors(getData) {
  var getList = getData;

  var getCount = function getCount(state) {
    var data = getList(state);
    return data === null ? null : data.length;
  };

  return {
    getList: getList,
    getCount: getCount
  };
};

function rjPlainList() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dataReducer = makeListDataReducer(config.customListReducer);
  return rjPlugin(rjListInsert(), rjListUpdate(), rjListDelete(), {
    selectors: function selectors(_ref2) {
      var getData = _ref2.getData;
      return makeListSelectors(getData);
    },
    reducer: function reducer(oldReducer) {
      return function (state, action) {
        if (action.type === SUCCESS) {
          return _objectSpread(_objectSpread({}, state), {}, {
            pending: false,
            data: dataReducer(state.data, action)
          });
        } else {
          return oldReducer(state, action);
        }
      };
    }
  });
}

export default rjPlainList;
export { makeListDataReducer, makeListSelectors };
